<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p9"><span class="sz"><b>Dedication</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p2"><span class="sz"> </span></p>
<p class="p7"><span class="sz">I'd like to dedicate this book to my sister, Sarah Goodman, who has supported me throughout my writing career. It was she who convinced me I should write a cozy mystery series and encouraged me to do so. Along the way, she's been my proofreader and sounding board. Sarah has been the best sister anyone could ever wish for, and I feel very fortunate to have her in my life. Thanks sis!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?32012948